import { Close } from "@mui/icons-material";
import { Dialog, IconButton } from "@mui/material";

import { Coursebook } from "./Coursebook";
import { DialogContent } from "./CoursebookModal.elements";
import { MiniControls } from "./MiniControls";

export function CoursebookModal({
  open,
  setOpen,
  handleChangeFontSize,
  fontSize,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
  handleChangeFontSize(fontSize: number): void;
  fontSize: number;
}): React.ReactElement | null {
  const toggleModal = (open: boolean) => () => setOpen(open);

  return (
    <Dialog open={open} onClose={toggleModal(false)} maxWidth="md" PaperProps={{ sx: { width: "1000px" } }}>
      <IconButton
        aria-label="close"
        onClick={toggleModal(false)}
        sx={{
          position: "absolute",
          right: "0.5em",
          top: "0.5em",
          color: theme => theme.palette.grey[300],
        }}
      >
        <Close />
      </IconButton>
      <DialogContent>
        <Coursebook
          isModal
          titleSize={6}
          fontSize={fontSize}
          handleChangeFontSize={handleChangeFontSize}
          customControl={<MiniControls />}
        />
      </DialogContent>
    </Dialog>
  );
}
